module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/img-18-ce7f4d19549d725c7ba7bbd7e4452241.png";